import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../app.config';
import { urlBuildWithParams, urlJoin, URLParamValue } from '../../../core/helpers/url.helper';
import { RecordsRequest, RecordsResponse } from './records.component.model';
import { Observable } from 'rxjs';
import { SearchLeadsRequest, SearchLeadsResponse } from '../leads/leads.component.model';

@Injectable({
  providedIn: 'root'
})
export class RecordsService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);

  private readonly url = urlJoin(this.appConfig.url, 'records');

  getFilesList(
    recordsRequest: RecordsRequest,
    page = 0,
    size = 10,
    sortProperty?: string,
    sortDirection?: string
  ): Observable<RecordsResponse> {
    const paramsMap = new Map<string, URLParamValue>();
    paramsMap.set('page', page);
    paramsMap.set('size', size);
    paramsMap.set('sortProperty', sortProperty);
    paramsMap.set('sortDirection', sortDirection);
    return this.httpClient.post<RecordsResponse>(
      urlBuildWithParams(urlJoin(this.url, 'my-files'), paramsMap),
      recordsRequest
    );
  }

  searchLeads(searchLeadsRequest: SearchLeadsRequest, page = 0, size = 10): Observable<SearchLeadsResponse> {
    const paramsMap = new Map<string, URLParamValue>();
    paramsMap.set('page', page);
    paramsMap.set('size', size);
    return this.httpClient.post<SearchLeadsResponse>(
      urlBuildWithParams(urlJoin(this.url, 'search-leads'), paramsMap),
      searchLeadsRequest
    );
  }
}
